.right-navbar-section{display:flex;align-items:center;gap:16px}
/*# sourceMappingURL=production-workspace-navbar.component.css.map */
